import {AuwConsentContainer} from "./AuwConsentContainer";


if($('.auw-consent-container').length) {
    $.each($('.auw-consent-container'),function(i,e) {
        new AuwConsentContainer($(e));
    });
}



